import * as React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { Loader } from "semantic-ui-react";

import { selectAndMergeCustomQuestionnaireConfigFactory } from "@teamprevent/common/questionnaires/questionnaireConfig/selectors";
import { QuestionnaireConfig, QuestionnaireConfigState } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import { masterConfig } from "../../questionnaireConfig/referral/masterConfig";

import { ReferralForm } from "./ReferralForm";

import { push } from "redux-little-router";

interface Props {
    questionnaireConfig: QuestionnaireConfig;
    api?: string;
    afterSubmit: (ohCaseId: string) => void;
    loadOrgStructure: (parentOrgStructureLevelId: string) => void;
    useAutoSave?: boolean;
    referAgainOhCaseId?: string;
    documentBaseApi: string;
}

const selectAndMergeReferralQuestionnaireConfig = selectAndMergeCustomQuestionnaireConfigFactory(
    masterConfig,
    (state: { questionnaireConfig: QuestionnaireConfigState }) => state.questionnaireConfig.referral
);

export class WritableReferralFormUnconnected extends React.Component<Props> {
    public render() {
        if (this.props.questionnaireConfig) {
            return (
                <ReferralForm
                    readonly={false}
                    questionnaireConfig={this.props.questionnaireConfig}
                    api={this.props.api}
                    afterSubmit={this.props.afterSubmit}
                    loadOrgStructure={this.props.loadOrgStructure}
                    useAutoSave={this.props.useAutoSave}
                    referAgainOhCaseId={this.props.referAgainOhCaseId}
                    documentBaseApi={this.props.documentBaseApi}
                />
            );
        }

        return <Loader active />;
    }
}

const mapStateToProps = (state: { questionnaireConfig: QuestionnaireConfigState }) => ({
    questionnaireConfig: selectAndMergeReferralQuestionnaireConfig(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<undefined, undefined, Action>) => ({
    afterSubmit: () => dispatch(push("/"))
});

export const WritableReferralForm = connect(mapStateToProps, mapDispatchToProps)(WritableReferralFormUnconnected);
